import { CreditCardIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import Radio from "shared/Radio/Radio";

const PAYMENT_METHODS = [
  { id: "Card", label: "Tarjeta de Crédito/Débito" },
  { id: "Bizum", label: "Bizum" },
] as const;

interface Props {
  selected: "Card" | "Bizum";
  onChange: (method: "Card" | "Bizum") => void;
  isActive: boolean;
  onCloseActive: () => void;
  onOpenActive: () => void;
}

const PaymentMethod: FC<Props> = ({
  selected,
  onChange,
  isActive,
  onCloseActive,
  onOpenActive,
}) => {

  const renderPaymentMethod = () => {
    return (
      <div className="border border-slate-200 dark:border-slate-700 rounded-xl ">
        <div className="p-6 flex flex-col sm:flex-row items-start">
          <span className="hidden sm:block">
            <svg
              className="w-6 h-6 text-slate-700 dark:text-slate-400 mt-0.5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.92969 15.8792L15.8797 3.9292"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.1013 18.2791L12.3013 17.0791"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.793 15.5887L16.183 13.1987"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.60127 10.239L10.2413 3.599C12.3613 1.479 13.4213 1.469 15.5213 3.569L20.4313 8.479C22.5313 10.579 22.5213 11.639 20.4013 13.759L13.7613 20.399C11.6413 22.519 10.5813 22.529 8.48127 20.429L3.57127 15.519C1.47127 13.419 1.47127 12.369 3.60127 10.239Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 21.9985H22"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <div className="sm:ml-8">
            <h3 className=" text-slate-700 dark:text-slate-400 flex ">
              <span className="uppercase tracking-tight">MÉTODO DE PAGO</span>
              <svg
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.5"
                stroke="currentColor"
                className="w-5 h-5 ml-3 text-slate-900"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.5 12.75l6 6 9-13.5"
                />
              </svg>
            </h3>
            <div className="font-semibold mt-1 text-sm">
                <span className="">{selected === "Card" ? "Tarjeta de Crédito/Débito" : "Bizum"}</span>
                {selected === "Card" ? <CreditCardIcon className="ml-3 w-5 h-5 inline" /> : <img src="/unnamed.png" alt="Bizum" className="ml-3 w-24 h-10 inline" />}
              </div>
          </div>
        </div>

        <div
          className="border-t border-slate-200 dark:border-slate-700 px-6 py-7 space-y-6"
        >
          <div className="space-y-4">
            {PAYMENT_METHODS.map(({ id, label }) => (
              <div className="flex items-center space-x-4" key={id}>
                <Radio
                  name="payment-method"
                  id={id}
                  checked={selected === id}
                  onChange={() => onChange(id)}
                />
                <label htmlFor={id} className="font-medium">{label}</label>
              </div>
            ))}
          </div>

        </div>
      </div>
    );
  };

  return renderPaymentMethod();
};

export default PaymentMethod;
